export const SIZE = [
  'small',
  ''
]
